export const PRODUCT_VARIANT_FABRIC = 34;
export const PRODUCT_VARIANT_FLOOR_CUSHION = 40;
